/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Tournament = {
    properties: {
        dateFrom: {
            type: 'string',
            isRequired: true,
            format: 'date',
        },
        dateTo: {
            type: 'string',
            isRequired: true,
            format: 'date',
        },
        sports: {
            type: 'SportEnum',
            isRequired: true,
        },
        cup: {
            type: 'boolean',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
        matchSectionAmount: {
            type: 'number',
            isRequired: true,
        },
        matchSectionDurationMinutes: {
            type: 'number',
            isRequired: true,
        },
        matchSectionPauseDurationMinutes: {
            type: 'number',
            isRequired: true,
        },
        price: {
            type: 'string',
            isRequired: true,
        },
        link: {
            type: 'string',
            isRequired: true,
        },
        location: {
            type: 'any-of',
            contains: [{
                type: 'Location',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        pdf: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        teams: {
            type: 'array',
            contains: {
                type: 'TeamSmall',
            },
            isRequired: true,
        },
    },
} as const;
